import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyEmployeeService {

  private messageSource = new BehaviorSubject({});
  currentEditUser = this.messageSource.asObservable();

  constructor(public apiService: ApiService) { }

  changeEditUser(data: any) {
    this.messageSource.next(data);
  }

  getAllCompanyEmployes(body: any): Observable<any> {
    return this.apiService.post('CompanyUsers/getAllCompanyUsers', body);
  }

  addCompanyEmployee(body: any): Observable<any> {
    return this.apiService.post('User/createCompanyUsers', body);
  }

  editCompanyEmployee(body: any): Observable<any> {
    return this.apiService.post('', body);
  }

  getCompanyEmployeesByRoles(body: any): Observable<any> {
    // return this.apiService.post('userrole/getEmployeesbyRole', body)
    return this.apiService.post('Roles/getUsersByRoleAndTask', body);
  }

  loginCompanyEmployee(body: any): Observable<any> {
    // return this.apiService.post('companyemployee/loginEmployee', body)
    return this.apiService.post('User/loginUser', body);
  }

  comapanyEmployeeForgotPswdCheckUsername(body: any): Observable<any> {
    // return this.apiService.post('User/checkEmailForUpdatePassword', body)
    return this.apiService.post('ResetPasswordKey/sendLinkForUpdatePassword', body);
  }

  companyEmployeeResetPassword(body: any): Observable<any> {
    return this.apiService.post('User/updatePassword', body);
  }

  getEmployeesToAddMasterUser(body: any): Observable<any> {
    // return this.apiService.post('userrole/getEmployeesByFilter', body)
    return this.apiService.post('CompanyUsers/getCompanyUsersForMaster', body);

  }

  getEmployeesToAddMasterSubUser(body: any): Observable<any> {
    return this.apiService.post('CompanyUsers/getCompanyUsersToAddSubUsers', body);
  }

  removeCmpyUsers(body: any): Observable<any> {
    // for listing page
    // return this.apiService.post('CompanyUsers/removeCompanyUsers', body)
    return this.apiService.post('CompanyUsers/removeCompanyUsers', body);

  }
  removeUserRoles(body: any): Observable<any> {
    // for manageusers
    return this.apiService.post('CompanyUserRole/removeUsersRoles', body);
  }
 getUpdatedRoleUser(body: any): Observable<any> {
    return this.apiService.post('User/getUpdatedRoles', body);
}
 getAllSalesControllerUsers(body: any): Observable<any> {
  return this.apiService.post('CompanyUsers/getSalesControllersusers', body);
}
getAllWarehouseControllerUsers(body: any): Observable<any> {
  return this.apiService.post('CompanyUsers/getWarehouseControllerUsers', body);
}
getAllWarehouseandProductionControllerUsers(body: any): Observable<any> {
  return this.apiService.post('CompanyUsers/getAllwarehouseandproductionUsers', body);
}
}
